export default __webpack_public_path__ + "static/media/sun.f794832a.png";